import Main from '@/views/main'

const routes = [
  {
    path: '/',
    name: 'Login',
    meta: { title: '登录' },
    component: () => import('@/views/login')
  },
  {
    path: '/home',
    name: 'Home',
    redirect: '/home',
    meta: {
      title: '首页'
    },
    component: Main,
    children: [
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: '首页',
          icon: 'fa-home'
        },
        component: () => import('@/views/home')
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        meta: {
          title: '仪表监控',
          icon: 'fa-tachometer-alt'
        },
        component: () => import('@/views/dashboard')
      }
    ]
  },
  {
    path: '',
    name: 'UserModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/member',
        name: 'MonthlyUserList',
        meta: {
          title: '包月用户',
          icon: 'fa-user',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/user')
      }
      // {
      //   path: '/member/temporary',
      //   name: 'TemporaryUserList',
      //   meta: {
      //     title: '临停用户',
      //     icon: 'fa-user',
      //     beforeCloseName: 'before_close_normal'
      //   },
      //   component: () => import('@/views/user/temporary')
      // }
    ]
  },
  {
    path: '',
    name: 'VehicleModule',
    redirect: '/vehicle/list',
    component: Main,
    children: [
      {
        path: '/vehicleType',
        name: 'VehicleTypeList',
        meta: {
          title: '车辆类型',
          icon: 'fa-hockey-puck',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/vehicle/vehicleType')
      },
      {
        path: '/vehicle',
        name: 'VehicleList',
        meta: {
          title: '车辆列表',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/vehicle')
      },
      {
        path: '/trace',
        name: 'VehicleTraceList',
        meta: {
          title: '出入记录',
          icon: 'fa-list',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/vehicle/trace')
      }
    ]
  },
  {
    path: '',
    name: 'AdModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/ad/list',
        name: 'AdList',
        meta: {
          title: '广告列表',
          icon: 'fa-ad',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/ad')
      }
    ]
  },
  {
    path: '',
    name: 'ParkingModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/garage',
        name: 'ParkingList',
        meta: {
          title: '车库列表',
          icon: 'fa-warehouse',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/parking')
      },
      {
        path: '/provisioning',
        name: 'ParkingProvisioning',
        meta: {
          title: '配置下发',
          icon: 'fa-cog',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/ops/provision/provision')
      },
      {
        path: '/terminal',
        name: 'ParkingTraceList',
        meta: {
          title: '终端日志',
          icon: 'fa-tablet-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/parking/trace')
      }
    ]
  },
  {
    path: '/finance',
    name: 'FinanceModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/receipt',
        name: 'ReceiptList',
        meta: {
          title: '交易记录',
          icon: 'fa-hand-holding-usd',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/finance/receipt')
      },
      {
        path: '/deposit',
        name: 'DepositList',
        meta: {
          title: '押金管理',
          icon: 'fa-money-check-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/finance/deposit')
      },
      {
        path: '/statistics',
        name: 'Statistics',
        meta: {
          title: '财务报表',
          icon: 'fa-hand-holding-usd',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/finance/statistics')
      }
    ]
  },
  {
    path: '',
    name: 'ProductModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/product',
        name: 'ProductList',
        meta: {
          title: '产品分类',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/product')
      },
      {
        path: '/quotation',
        name: 'ProductQuotation',
        meta: {
          title: '产品报价',
          icon: 'fa-dollar-sign',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/product/productQuotation')
      }
    ]
  },
  // 账户中心
  {
    path: '',
    name: 'AccountModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/account/dashboard',
        name: 'Account',
        meta: {
          title: '个人账户',
          icon: 'fa-wallet',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/account/dashboard')
      },
      {
        path: '/account/contract',
        name: 'Contract',
        meta: {
          title: '合同管理',
          icon: 'fa-file-contract',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/account/contract')
      },
      {
        path: '/account/settlement',
        name: 'SettlementtList',
        meta: {
          title: '提现管理',
          icon: 'fa-credit-card',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/account/settlement')
      },
      {
        path: '/account/refundment',
        name: 'RefundmentList',
        meta: {
          title: '退款记录',
          icon: 'fa-money-check-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/account/refundment')
      }
    ]
  },
  // 合伙人管理
  {
    path: '',
    name: 'PartnerModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/partner',
        name: 'PartnerList',
        meta: {
          title: '合伙人列表',
          icon: 'fa-list-ul',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/partner')
      },
      {
        path: '/partner/role',
        name: 'PartnerRoleList',
        meta: {
          title: '合伙人角色',
          icon: 'fa-award',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/partner/role')
      },
      {
        path: '/partner/contract',
        name: 'PartnerContractList',
        meta: {
          title: '合伙人合同',
          icon: 'fa-file-signature',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/partner/contract')
      }
    ]
  },
  // 运维
  {
    path: '',
    name: 'OpsModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/ops/device',
        name: 'DeviceAlarm',
        meta: {
          title: '设备告警',
          icon: 'fa-tablet',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/ops/device')
      },
      {
        path: '/ops/emergency',
        name: 'EmergencyCall',
        meta: {
          title: '紧急呼叫',
          icon: 'fa-phone-square',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/ops/emergency')
      },
      {
        path: '/ops/swm',
        name: 'ParkingSoftwareManager',
        meta: {
          title: '终端管理',
          icon: 'fa-sitemap',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/ops/swm')
      }
    ]
  },
  // 临停管理
  {
    path: '',
    name: 'TemporaryParkingModule',
    redirect: '/',
    component: Main,
    children: [
      {
        path: '/temporary/user',
        name: 'TemporaryUserList',
        meta: {
          title: '临停用户',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/temporary/user')
      },
      {
        path: '/temporary/vehicle',
        name: 'TemporaryVehicleList',
        meta: {
          title: '临停车辆',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/temporary/vehicle')
      },
      {
        path: '/temporary/deposit',
        name: 'TemporaryDepositList',
        meta: {
          title: '临停押金',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/temporary/deposit')
      },
      {
        path: '/temporary/trace',
        name: 'TemporaryTraceList',
        meta: {
          title: '临停记录',
          icon: 'fa-list-alt',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/temporary/trace')
      }
    ]
  },
  // {
  //   path: '/device',
  //   name: 'DeviceModule',
  //   redirect: '/device/list',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/device/list',
  //       name: 'DeviceList',
  //       meta: {
  //         title: '设备管理',
  //         icon: 'fa-coins',
  //         beforeCloseName: 'before_close_normal'
  //       },
  //       component: () => import('@/views/device')
  //     }
  //   ]
  // },
  // {
  //   path: '/trace',
  //   name: 'Trace',
  //   redirect: '/trace/list',
  //   component: Main,
  //   children: [
  //     {
  //       path: '/trace/list',
  //       name: 'TraceList',
  //       meta: {
  //         title: '日志管理',
  //         icon: 'fa-list',
  //         beforeCloseName: 'before_close_normal'
  //       },
  //       component: () => import('@/views/trace')
  //     }
  //   ]
  // },
  {
    path: '/system',
    name: 'System',
    redirect: '/trace/list',
    component: Main,
    children: [
      {
        path: '/system/logs',
        name: 'SystemLogs',
        meta: {
          title: '系统日志',
          icon: 'fa-list',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/logs')
      },
      {
        path: '/system/config',
        name: 'SystemConfigs',
        meta: {
          title: '数据字典',
          icon: 'fa-book',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/config')
      },
      {
        path: '/system/menu',
        name: 'SystemMenu',
        meta: {
          title: '菜单管理',
          icon: 'fa-sitemap',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/menu')
      },
      {
        path: '/system/contract',
        name: 'UserContract',
        meta: {
          title: '文档管理',
          icon: 'fa-file-contract',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/contract')
      },
      {
        path: '/system/permission',
        name: 'SystemPermission',
        meta: {
          title: '权限管理',
          icon: 'fa-user-cog',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/role')
      },
      {
        path: '/system/config',
        name: 'SystemConfig',
        meta: {
          title: '系统配置',
          icon: 'fa-cog',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system')
      },
      {
        path: '/system/token',
        name: 'SystemToken',
        meta: {
          title: '令牌管理',
          icon: 'fa-key',
          beforeCloseName: 'before_close_normal'
        },
        component: () => import('@/views/system/token')
      }
    ]
  }
]
export default routes

